export default __webpack_public_path__ + "8118e283d5a8b9434cd1480801f6b8d6.svg";